export default __webpack_public_path__ + "static/media/AppleCareLogo.5d97edcc.svg";